import * as React from 'react';
import { onComponentEventAction } from '../../../shared/componentEventActionEmitter';
import { componentNodeMap, getComponentNode } from '../../../shared/componentNodeMap';
import { emitCustomEvent } from '../../../shared/customEventTrigger';
import { HotAreas } from '../../HotAreas';

export function ReactAdaptor({ instance, injectProps = {}, meta, global, useLandscapeCommonStyle, useLandscapeStyle, useLandscapeAnimateData }) {
  const {
    component = {},
    data,
    style,
    animateData,
    landscapeAnimateData,
    landscapeStyle,
    commonStyle,
    landscapeCommonStyle,
    key,
  } = instance;

  const { customConfig } = component;

  const orientationCommonStyle = useLandscapeCommonStyle ? landscapeCommonStyle : commonStyle;
  const orientationStyle = useLandscapeStyle ? landscapeStyle : style;
  const orientationAnimateData = useLandscapeAnimateData ? landscapeAnimateData : animateData;

  const View = instance.component.component;

  const hotAreas = component.__implementHotArea ? <HotAreas global={global} meta={meta} instance={instance} /> : null;

  const emit = (trigger, payload) => emitCustomEvent(instance, trigger, global, meta, payload);

  const on = (eventName, callback) => onComponentEventAction(instance, eventName, callback);

  if (!View) {
    console.error(`Cannot find component [${component.name}] by id [${component.id}]`);
    return null;
  }

  return (
    <View
      key={key}
      componentKey={key}
      data={data}
      style={orientationStyle}
      customConfig={customConfig}
      commonStyle={orientationCommonStyle}
      animateData={orientationAnimateData}
      global={global}
      meta={meta}
      emit={emit}
      on={on}
      hotAreas={hotAreas}
      componentsMap={componentNodeMap}
      getComponentByKey={getComponentNode}
      {...injectProps}
    />
  );
}
